import { Block } from 'baseui/block';
import { Card } from 'baseui/card';
import { StyledDivider } from 'baseui/divider';
import { memo } from 'react';
import GptEventCardCardBody from './GptEventCardBody';
import GptEventCardCardHeader from './GptEventCardHeader';
import { EventCore } from '../../types/gptTypes';

type Props = {
  event: EventCore;
};
function GptEventCard({ event }: Readonly<Props>) {

  if (!event) {
    return <></>; // TODO: skeleton
  }

  return (
    <Block>
      <Card
        overrides={{
          Root: {
            style: {
              height: 'calc(100% - 16px)',
              boxSizing: 'border-box',
              borderLeftWidth: '1px',
              borderRightWidth: '1px',
              borderTopWidth: '1px',
              borderBottomWidth: '1px',
            },
          },
          Contents: {
            style: {
              marginTop: 0,
              marginRight: 0,
              marginBottom: 0,
              marginLeft: 0,
            },
          },
          Body: {
            style: {
              marginBottom: 0,
            },
          },
        }}
      >
        <GptEventCardCardHeader event={event} />
        <StyledDivider
          $size="cell"
          style={{ marginTop: 0, marginBottom: 0 }}
        />
        <GptEventCardCardBody event={event} />
      </Card>
    </Block>
  );
}

export default memo(GptEventCard);
